import * as React from "react";
import { Context } from "./_context";
export const ShareAndroidIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.5 1a3.5 3.5 0 1 1-2.287 6.148l-6.31 4.033a3.506 3.506 0 0 1-.015 1.699l6.277 4.012a3.5 3.5 0 1 1-1.047 1.704L7.853 14.59a3.5 3.5 0 1 1 .044-5.14l6.238-3.987A3.5 3.5 0 0 1 17.5 1Zm0 17a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-12-7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm12-7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z", fill: "currentColor" }));
  return iconset[size];
};
ShareAndroidIcon.iconId = "on6UuU";
